import { ACTION_NAMES } from "../utils/actionConstants";
import { history } from "../store";
import applicationService from "../services/Application.service";
import { refresh } from "../utils/refresh";
import { apigClientFactory } from '../apiGateway/apigClientFactory';

const authClientMap = new Map([
  [ "zooxalpha.amazonstock.com", "zooxalpha.amazonstock.com" ],
  [ "zooxbeta.amazonstock.com", "zooxbeta.amazonstock.com" ],
  [ "zooxadams.amazonstock.com", "zooxadams.amazonstock.com" ],
  [ "zooxbaker.amazonstock.com", "zooxbaker.amazonstock.com" ],
  [ "zoox.amazonstock.com", "zoox.amazonstock.com" ]
]);

const requestAuthentication = () => ({
  type: ACTION_NAMES.AUTH.REQUEST_AUTHENTICATION,
  payload: null,
});

const requestAuthenticationError = (error) => ({
  type: ACTION_NAMES.AUTH.REQUEST_AUTHENTICATION_ERROR,
  payload: error,
});

const receiveAuthentication = (auth) => ({
  type: ACTION_NAMES.AUTH.RECEIVE_AUTHENTICATION,
  payload: auth,
});

const requestImpersonation = (employeeId) => ({
  type: ACTION_NAMES.AUTH.REQUEST_IMPERSONATION,
  payload: employeeId,
});

const receiveImpersonation = (auth) => ({
  type: ACTION_NAMES.AUTH.RECEIVE_IMPERSONATION,
  payload: auth,
});

const receiveImpersonationError = () => ({
  type: ACTION_NAMES.AUTH.RECEIVE_IMPERSONATION_ERROR,
  payload: null,
});

const requestRemoveImpersonation = () => ({
  type: ACTION_NAMES.AUTH.REQUEST_REMOVE_IMPERSONATION,
  payload: null,
});

const receiveRemoveImpersonation = (auth) => ({
  type: ACTION_NAMES.AUTH.RECEIVE_REMOVE_IMPERSONATION,
  payload: auth,
});

const logoutAuthentication = () => ({
  type: ACTION_NAMES.AUTH.LOGOUT_AUTHENTICATION,
  payload: null,
});

const findAuthClient = (hostname) => {
  if (hostname === null || hostname === undefined)
  {
    return
  }

  return authClientMap.get(hostname.toLowerCase())
};

const getRoute = (pathname) => {
  if (["/dashboard", "/stock-awards", "/broker", '/more-about-stock'].includes(pathname)){
    return pathname;
  }
  else {
    return "/dashboard";
  }
};

export const actions = {
  clearAuthenticationError: () => ({
    type: ACTION_NAMES.AUTH.CLEAR_AUTHENTICATION_ERROR,
    payload: null,
  }),
  authenticate: () => (dispatch, getState) => {
    const state = getState();

    if (process.env.REACT_APP_PERF_AUTH === "true") {
      if (!(state && state.auth && state.auth.auth)) {
        var server_url = new URL(process.env.REACT_APP_API_GATEWAY);
        const randomNonce = applicationService.generateRandomNonce(20);
        const amazonId = process.env.REACT_APP_AUTH_AMAZONID;
        const emplId = process.env.REACT_APP_AUTH_EMPLID;
        const myRequest = new Request(
          `${server_url.origin}/api/authentication-perf?token=${randomNonce}:${amazonId}:${emplId}`
        );

        fetch(myRequest, {
          method: "GET",
          mode: "cors",
          headers: {
            "content-type": "application/json",
            Accept: "application/json",
          },
        })
          .then((res) => {
            if (res.ok) {
              return res.json(); // expecting a json response
            }

            throw new Error(res.status);
          })
          .then(
            ({ employee_id, security_token, refresh_token, security_exp }) => {
              const auth = {
                secret: security_token,
                refresh: refresh_token,
                id: employee_id,
                secret_exp: security_exp,
              };

              /* global digitalData */
              digitalData.empId = employee_id;

              if (
                !(
                  employee_id === null ||
                  employee_id === undefined ||
                  employee_id === ""
                )
              ) {
                document.body.dispatchEvent(new Event("logged_in"));
              }

              dispatch(receiveAuthentication(auth));

              if (employee_id === "") {
                history.push("/impersonate");
              } else {
                history.push(getRoute(window.location.pathname));
              }
            }
          )
          .catch((ex) => {
            dispatch(requestAuthenticationError(ex.message));
          });
      }
    } else {
      if (!(state && state.auth && state.auth.auth)) {
        // Define the client id
        const actual_url = new URL(window.location);
        var client_id = actual_url.searchParams.get("AuthClient");

        if (!client_id) {
          client_id = findAuthClient(actual_url.hostname)
        }

        if (!client_id) {
          client_id = process.env.REACT_APP_FALLBACK_CLIENT_ID;
        }

        // save the current location
        sessionStorage.setItem('previousPathname', window.location.pathname);
        const randomNonce = applicationService.generateRandomNonce(20);
        const state = randomNonce + "_" + client_id;
        const authUrl = `${process.env.REACT_APP_API_OAUTH}&nonce=${randomNonce}&state=${state}&client_id=${client_id}`;
        window.location = authUrl;
      }
    }
  },
  oAuthAthenticate: (code, state) => (dispatch) => {
    dispatch(requestAuthentication());
    var server_url = new URL(process.env.REACT_APP_API_GATEWAY);
    const myRequest = new Request(
      `${server_url.origin}/api/authentication?code=${code}&state=${state}`
    );

    fetch(myRequest, {
      method: "GET",
      mode: "cors",
      headers: {
        "content-type": "application/json",
        Accept: "application/json",
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json(); // expecting a json response
        }

        throw new Error(res.status);
      })
      .then(({ employee_id, security_token, refresh_token, security_exp }) => {
        const auth = {
          secret: security_token,
          refresh: refresh_token,
          id: employee_id,
          secret_exp: security_exp,
        };

        /* global digitalData */
        digitalData.empId = employee_id;

        if (
          !(
            employee_id === null ||
            employee_id === undefined ||
            employee_id === ""
          )
        ) {
          document.body.dispatchEvent(new Event("logged_in"));
        }

        dispatch(receiveAuthentication(auth));

        if (employee_id === "") {
          history.push("/impersonate");
        } else {
          const previousPathname = sessionStorage.getItem('previousPathname');
          history.push(getRoute(previousPathname ? previousPathname : "/"));
        }
      })
      .catch((ex) => {
        dispatch(requestAuthenticationError(ex.message));
      });
  },
  receiveAuthentication: () => (dispatch) => {
    const hash_url = window
      .decodeURIComponent(window.location.hash)
      .substr(1)
      .trim();
    var tokens = hash_url.split("&");

    const secret = tokens[0].substr("security_token=".length);
    const refresh = tokens[1].substr("refresh_token=".length);
    const id = tokens[2].substr("id=".length);

    const auth = {
      secret: secret,
      refresh: refresh,
      id,
    };

    dispatch(receiveAuthentication(auth));

    if (id === "") {
      history.push("/impersonate");
    } else {
      history.push(getRoute(window.location.pathname));
    }
  },
  logout: () => (dispatch) => {
    console.log("Logging out user ....");
    digitalData.empId = null;
    document.body.dispatchEvent(new Event("logged_out"));
    dispatch(logoutAuthentication());
    history.push("/dashboard");
  },
  impersonateEmployee: (employeeId, successCallback, errorCallback) => async (dispatch, getState) => {
    const state = getState();

    try {
      await refresh(state.auth.auth);
    } catch (error) {
      console.log("Refresh Error: " + error);
      history.push("/logout");
      return;
    }

    dispatch(requestImpersonation(employeeId));

    var apigClient;
    if (process.env.REACT_APP_API_GATEWAY) {
      apigClient = apigClientFactory.newClient({
        invokeUrl: process.env.REACT_APP_API_GATEWAY,
      });
    } else {
      apigClient = apigClientFactory.newClient();
    }

    var params = {
      id: employeeId,
      Authorization: `Bearer ${state.auth.auth.secret}`,
    };

    var body = {};
    var additionalParams = {};

    apigClient
      .impersonateUserPost(params, body, additionalParams)
      .then((result) => {
        console.log("success impersonating");
        const auth = {
          secret: result.data.security_token,
          refresh: result.data.refresh_token,
          id: result.data.employee_id,
          secret_exp: result.data.security_exp,
        };

        /* global digitalData */
        digitalData.buttonClicked = "Start Impersonate";
        digitalData.impersonation = "Y";
        document.body.dispatchEvent(new Event("button_clicked"));

        dispatch(receiveImpersonation(auth));
        successCallback();
      })
      .catch((error) => {
        console.log("Error. impersonating employee");
        dispatch(receiveImpersonationError());
        errorCallback(error);
      });
  },
  removeImpersonate: (callback) => async (dispatch, getState) => {
    console.log("Remove impersonate");
    const state = getState();

    try {
      await refresh(state.auth.auth);
    } catch (error) {
      console.log("Refresh Error: " + error);
      history.push("/logout");
      return;
    }

    /* global digitalData */
    digitalData.buttonClicked = "Stop Impersonate";
    digitalData.impersonation = "N";
    document.body.dispatchEvent(new Event("button_clicked"));

    dispatch(requestRemoveImpersonation());

    var apigClient;
    if (process.env.REACT_APP_API_GATEWAY) {
      apigClient = apigClientFactory.newClient({
        invokeUrl: process.env.REACT_APP_API_GATEWAY,
      });
    } else {
      apigClient = apigClientFactory.newClient();
    }
    const id = state.auth.auth.id;

    var params = {
      id,
      Authorization: `Bearer ${state.auth.auth.secret}`,
    };

    var body = {};
    var additionalParams = {};

    return apigClient
      .impersonateUserDelete(params, body, additionalParams)
      .then((result) => {
        console.log("success remove impersonating");
        const auth = {
          secret: result.data.security_token,
          refresh: result.data.refresh_token,
          id: result.data.employee_id,
          secret_exp: result.data.security_exp,
        };

        dispatch(receiveRemoveImpersonation(auth));
        callback(result.data.employee_id);
      })
      .catch((error) => {
        console.log("Error. remove impersonating employee");
      });
  },
};
